export default defineNuxtPlugin(() => {
  console.log(
    `%c
  ██████╗ ███████╗██████╗
 ██╔════╝ ██╔════╝██╔══██╗
 ██║  ███╗███████╗██║  ██║
 ██║   ██║╚════██║██║  ██║
 ╚██████╔╝███████║██████╔╝
  ╚═════╝ ╚══════╝╚═════╝
  Tech Solutions
`,
    "color: #E8636A; font-family: monospace; font-size: 12px;",
  );
  console.log(
    "%cIf you want to build your next app, visit us at %cwww.gsdtechsolutions.com",
    "color: #8C8C8C; font-size: 13px;",
    "color: #E8636A; font-size: 13px; font-weight: bold; text-decoration: underline;",
  );
});
